import { CalciteLabel } from '@esri/calcite-components-react';
import { ThemeManager } from '../ThemeManager';

export default function AppSettingsPanel(): JSX.Element {
  return (
    <div className="p-4">
      <CalciteLabel layout="inline-space-between">
        Theme
        <ThemeManager />
      </CalciteLabel>
    </div>
  );
}
